<template>
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9.5" cy="9.5" r="9" stroke="#E5E5E5"/>
    <path
        d="M9.49999 12.1303C9.33869 12.1303 9.17741 12.0687 9.05443 11.9458L5.18463 8.07592C4.93846 7.82975 4.93846 7.43062 5.18463 7.18455C5.4307 6.93848 5.82974 6.93848 6.07593 7.18455L9.49999 10.6088L12.9241 7.18467C13.1702 6.9386 13.5692 6.9386 13.8153 7.18467C14.0616 7.43074 14.0616 7.82986 13.8153 8.07603L9.94554 11.9459C9.8225 12.0688 9.66122 12.1303 9.49999 12.1303Z"
        fill="#87939E"/>
  </svg>
</template>
